/**
 * Whether the master account the session acts in may register Bridges: the server's
 * `master-account-bridges` flag, evaluated per master account.
 */
import { useQuery } from '@apollo/client/react';
import { GetMasterAccountBridgesEnabledDocument } from '@/graphql';

export interface MasterAccountBridgesEnabled {
  enabled: boolean;
  loading: boolean;
}

export function useMasterAccountBridgesEnabled(
  options: { skip?: boolean } = {}
): MasterAccountBridgesEnabled {
  const { data, loading } = useQuery(GetMasterAccountBridgesEnabledDocument, {
    skip: options.skip,
    fetchPolicy: 'cache-first'
  });
  return {
    enabled: data?.profile?.currentMasterAccount?.bridgesEnabled === true,
    loading
  };
}
